
import { writable } from 'svelte/store';
import { fetchWithSession } from '../util/fetchWithSession';

export function creatingSettingStores() {
  const  { subscribe, set, update }  = writable({
    users: [],
    roles: [],
    teams: [],
    groups: [],
    permissions : [],
  })

  async function getAvailableValues() {
    fetchWithSession(`/api/authentication/settings/available-values`)
      .then((response) => response.json())
      .then((data) => {
        update(state => ({
          ...state,
          roles: data.roles.map((d) => {
            return {
              value: d.value,
              text: d.label,
            };
          }),
          permissions: data.permissions,
        }))
      
      });
  }

  async function getUsers() {
     fetchWithSession(`/api/authentication/settings/users`)
      .then((response) => response.json())
      .then((data) => {
        update(state => ({
          ...state,
          groups: state.groups.length > 0 ? state.groups : data.available_groups.map((d) => {
              return {
                id: d.id,
                text: d.name,
              }
            }),
          teams: state.teams.length > 0 ? state.teams : data.available_teams.map((d) => {
              return {
                id: d.id,
                text: d.name,
              }
            }),
           users: data.data,
        }))
      });
  }

  async function getTeams() {
    fetchWithSession(`/api/authentication/settings/teams`)
      .then((response) => response.json())
      .then((data) => {
        update(state => ({
          ...state,
          users: state.users.length > 0 ? state.users : data.available_users,
          teams: data.data.map((team) => {
            return {
            id: team.id,
            text: team.name,
            users: team.users.map((user) => {
              return { email: user.email, id: user.id, name: user.username };
            }),
            nUsers: team?.users?.length || 0,
          };
          }),
        }));
      });
  }

  function getGroups() {
    fetchWithSession(`/api/authentication/settings/groups`)
      .then((response) => response.json())
      .then((data) => {
       update(state => ({
          ...state,
           users: state.users.length > 0 ? state.users : data.available_users,
          groups: data.data.map((d) => {
            return {
               id: d.id,
            text: d.name,
            permissions: d.permissions,
            users: d.users.map((u) => {
              return { id: u.id, name: u.username };
            }),
             nUsers: d?.users?.length || 0,
            };
          }),
        }));
      });}

  function addUser(newUser) {
    update(state => {
      let newgroups = state.groups;
      let newTeams = state.teams;
      if(state.groups && state.groups.length > 0 && state.groups[0].users && newUser.groups.length > 0) {
        newgroups = newgroups.map(group => {
          if(newUser.groups.some(g => g.id === group.id)) {
            return {
              ...group,
              users: [...group.users, { id: newUser.id, name: newUser.username }],
              nUsers: group.nUsers + 1
            };
          }
          return group;
        });

      }
      if(state.teams && state.teams.length > 0 && state.teams[0].users && newUser.teams.length > 0) {
        newTeams = newTeams.map(team => {
          if(newUser.teams.some(g => g.id === team.id)) {
            return {
              ...team,
              users: [...team.users, { id: newUser.id, name: newUser.username, email: newUser.email }],
              nUsers: team.nUsers + 1
            };
          }
          return team;
        });

      }

      return {
        ...state,
        users: [...state.users, newUser],
        groups: newgroups,
        teams: newTeams,
      };
    });
  }

    function updateUser(updatedUser) {
    
      update(state => {
        const userToUpdate = state.users.length>0 ? state.users.find(user => user.id === updatedUser.id) : null;
        if (!userToUpdate) return state;
        let newgroups = state.groups;
        let newTeams = state.teams;

        if(state.teams && state.teams.length > 0 && state.teams[0].users && userToUpdate.teams) {
          const teamsWithoutUser = userToUpdate.teams.filter(a => !updatedUser.teams.some(b => b.id === a.id)).map(team => team.id);
          const teamsWithNewUser = updatedUser.teams.filter(b => !userToUpdate.teams.some(a => a.id === b.id)).map(team => team.id);
          if(teamsWithoutUser.length > 0 || teamsWithNewUser.length > 0) {
          newTeams = newTeams.map(team => {
            if(teamsWithoutUser.includes(team.id)) {
              return {
                ...team,
                users: team.users.filter(user => user.id !== updatedUser.id),
                nUsers: team.nUsers - 1
              };
            }
            else if(teamsWithNewUser.includes(team.id)) {
              return {
                ...team,
                users: [...team.users, { id: updatedUser.id, name: updatedUser.username, email: updatedUser.email }],
                nUsers: team.nUsers + 1
              };
            }

            return team;
          });

        }}
        if(state.groups && state.groups.length > 0 && state.groups[0].users && userToUpdate.groups) {
          const groupsWithoutUser = userToUpdate.groups.filter(a => !updatedUser.groups.some(b => b.id === a.id)).map(group => group.id);
          const groupsWithNewUser = updatedUser.groups.filter(b => !userToUpdate.groups.some(a => a.id === b.id)).map(group => group.id);
          if(groupsWithoutUser.length > 0 || groupsWithNewUser.length > 0) {
          newgroups = newgroups.map(group => {
            if(groupsWithoutUser.includes(group.id)) {
              return {
                ...group,
                users: group.users.filter(user => user.id !== updatedUser.id),
                nUsers: group.nUsers - 1
              };
            }
            else if(groupsWithNewUser.includes(group.id)) {
              return {
                ...group,
                users: [...group.users, { id: updatedUser.id, name: updatedUser.username }],
                nUsers: group.nUsers + 1
              };
            }

            return group;
          });
        }
      }
        return {
        ...state,
        users: state.users.map(user => user.id === updatedUser.id ? updatedUser : user),
        groups: newgroups,
        teams: newTeams,
      }
    })
  
    
  }

  function removeUser(userId) {
    update(state => {
      const userToRemove = state.users.find(user => user.id === userId);
      if (!userToRemove) return state;
      let newgroups = state.groups;
      let newTeams = state.teams;

      if(state.groups && state.groups.length > 0 && state.groups[0].users && userToRemove.groups.length > 0) {
        newgroups = newgroups.map(group => {
          if(userToRemove.groups.some(g => g.id === group.id)) {
            return {
              ...group,
              users: group.users.filter(user => user.id !== userId),
              nUsers: group.nUsers - 1
            };
          }
          return group;
        });

      }
      if(state.teams && state.teams.length > 0 && state.teams[0].users && userToRemove.teams.length > 0) {
        newTeams = newTeams.map(team => {
          if(userToRemove.teams.some(g => g.id === team.id)) {
            return {
              ...team,
              users: team.users.filter(user => user.id !== userId),
              nUsers: team.nUsers - 1
            };
          }
          return team;
        });

      }
      return {
        ...state,
        users: state.users.filter(user => user.id !== userId),
        groups: newgroups,
        teams: newTeams,
      }
    })
  }

    function updateTeam(updatedTeam) {
      update(state => {
                let newUsers = state.users;
        if(state.users && state.users.length > 0 && state.users[0].teams) {
        let teamBefore = state.teams.find(team => team.id === updatedTeam.id);
        if (!teamBefore) return state;

        let usersWithoutTeam = teamBefore.users.filter(a => !updatedTeam.users.some(b => b.id === a.id)).map(user => user.id);
        let usersWithTeam = updatedTeam.users.filter(b => !teamBefore.users.some(a => a.id === b.id)).map(user => user.id);

        if(usersWithTeam.length > 0 || usersWithoutTeam.length > 0) {
          newUsers = state.users.map(user => {
            if(usersWithoutTeam.includes(user.id)) {
              return {
                ...user,
                teams: user.teams.filter(team => team.id !== updatedTeam.id)
              };
            }
            else if(usersWithTeam.includes(user.id)) {
              return {
                ...user,
                teams: [...user.teams, { id: updatedTeam.id, name: updatedTeam.name }]
              };
            }
            return user;
          });
        }}
        return {
        ...state,
        users: newUsers,
        teams: state.teams.map(team => team.id === updatedTeam.id ? updatedTeam : team)
      }}
    )
    }

    function addTeam(newTeam) {
      update(state => 
        {
           let newUsers = state.users;
      if(state.users && state.users.length > 0 && state.users[0].teams && newTeam.users.length > 0) {
        newUsers = state.users.map(user => {
          if(newTeam.users.some(u => u.id === user.id)) {
            return {
              ...user,
              teams: [...user.teams, { id: newTeam.id, name: newTeam.name }]
            };
          }
          return user;
        } )
      }
        return{
        ...state,
        users: newUsers,
        teams: [...state.teams, newTeam]
      }})
    }


    function setTeams(teams) {
      update(state => ({
        ...state,
        teams: teams
      }))
    }

    function removeTeam(teamId) {
      update(state => {
        let newUsers = state.users;
        let deletedTeam = state.teams.find(team => team.id === teamId);
        if (!deletedTeam) return state;
        if(state.users && state.users.length > 0 && state.users[0].teams && deletedTeam.users.length > 0) {
          newUsers = state.users.map(user => {
            if(deletedTeam.users.some(u => u.id === user.id)) {
              return {
                ...user,
                teams: user.teams.filter(team => team.id !== teamId)
              };
            }
            return user;
          })
        }
        
        return{
        ...state,
        users: newUsers,
        teams: state.teams.filter(team => team.id !== teamId)
      }})
    }

    function updateGroup(updatedGroup) {
      update(state => {
        let newUsers = state.users;
        if(state.users && state.users.length > 0 && state.users[0].groups) {
        let groupBefore = state.groups.find(group => group.id === updatedGroup.id);
        if (!groupBefore) return state;
        let usersWithoutGroup = groupBefore.users.filter(a => !updatedGroup.users.some(b => b.id === a.id)).map(user => user.id);
        let usersWithGroup = updatedGroup.users.filter(b => !groupBefore.users.some(a => a.id === b.id)).map(user => user.id);

        if(usersWithGroup.length > 0 || usersWithoutGroup.length > 0) {
          newUsers = state.users.map(user => {
            if(usersWithoutGroup.includes(user.id)) {
              return {
                ...user,
                groups: user.groups.filter(group => group.id !== updatedGroup.id)
              };
            }
            else if(usersWithGroup.includes(user.id)) {
              return {
                ...user,
                groups: [...user.groups, { id: updatedGroup.id, name: updatedGroup.name }]
              };
            }
            return user;
          });

        }
      }
      return {
        ...state,
        users: newUsers,
        groups: state.groups.map(group => group.id === updatedGroup.id ? updatedGroup : group)
    }
  }
      )
    }

    function addGroup(newGroup) {
      update(state => {         
      let newUsers = state.users;
      if(state.users && state.users.length > 0 && state.users[0].groups && newGroup.users.length > 0) {
        newUsers = state.users.map(user => {  
          if(newGroup.users.some(u => u.id === user.id)) {
            return {
              ...user,
              groups: [...user.groups, { id: newGroup.id, name: newGroup.name }]
            };
            
          } return user;
        })
      }
        return{
        ...state,
        users: newUsers,
        groups: [...state.groups, newGroup]
      }})
    }

    function removeGroup(groupId) { 
      update(state => {
        let newUsers = state.users;
        let deletedGroup = state.groups.find(group => group.id === groupId);
        if(state.users && state.users.length > 0 && state.users[0].groups && deletedGroup?.users?.length > 0) {
          newUsers = state.users.map(user => {
            if(deletedGroup.users.some(u => u.id === user.id)) {
              return {
                ...user,
                groups: user.groups.filter(group => group.id !== groupId)
              };
            }
            return user;
          })
        }

        return{
        ...state,
        users: newUsers,
        groups: state.groups.filter(group => group.id !== groupId)
      }})
    }

    function updateGroups(groups) {
      update(state => ({
        ...state,
        groups: groups}))
  }
    function updateRoles(roles) {
      update(state => ({
        ...state,
        roles: roles
      }))
    }

return {
  subscribe,
  set,  
  update, 
  getAvailableValues,
  getUsers,
  updateUser,
  addUser,
  removeUser,
  getTeams,
  getGroups,
  addGroup,
  updateGroup,
  removeGroup,
  addTeam,
  removeTeam,
  updateTeam,
  setTeams,
  updateGroups,
  updateRoles,
}
}

  export const settingStores = creatingSettingStores();